export default __webpack_public_path__ + "static/media/purchaseImg.88c94ca1.svg";